package com.checkin.shared.model

import kotlinx.serialization.Serializable

@Serializable
enum class PropertyType {
    APPARTEMENT,
    VILLA,
    STUDIO,
    MAISON,
    RYAD,
    AUTRE,
}

/** Conservé pour compatibilité JSON ; non exposé dans l'UI. */
@Serializable
enum class PropertyStatus {
    ACTIVE,
    INACTIVE,
}

@Serializable
enum class ReservationStatus {
    PENDING,
    IN_PROGRESS,
    COMPLETED,
    CANCELLED,
}

@Serializable
enum class GuestStatus {
    PENDING,
    DOCUMENT_PROCESSING,
    DOCUMENT_VERIFIED,
    SELFIE_PROCESSING,
    FACE_MATCHED,
    CONTRACT_SIGNED,
    /** Contrat signé par l'invité ; en attente de validation par l'hôte. */
    AWAITING_HOST_REVIEW,
    COMPLETED,
}

@Serializable
enum class VerificationFilter {
    ALL,
    PENDING,
    COMPLETE,
}

@Serializable
enum class GuestVerificationStep {
    WELCOME,
    DOCUMENT,
    DOCUMENT_PROCESSING,
    SELFIE,
    SELFIE_PROCESSING,
    CONTRACT,
    AWAITING_HOST_REVIEW,
    COMPLETED,
}

@Serializable
enum class StepStatus {
    PENDING,
    IN_PROGRESS,
    COMPLETED,
    SKIPPED,
    FAILED,
}
